import { JSX, ReactElement } from 'react';
import {
    Create,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    ReferenceArrayInput,
    TextInput,
    required,
    FormDataConsumer,
    DateInput,
    FormDataConsumerRenderParams
} from 'react-admin';
import { currency, couponTypes, couponDuration } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const CouponCreate: () => JSX.Element = (): JSX.Element => {

    return (
        <Create>
            <SimpleForm >
                <TextInput source="name" validate={ [required()] } />
                <TextInput source="code" helperText={ "A random Code is generated if left empty" } />
                <SelectInput source="currency"
                             label="Currency"
                             name="currency"
                             choices={ currency }
                             validate={ [required()] } />
                <SelectInput
                    name="discountType"
                    source="discountType"
                    choices={ couponTypes }
                    validate={ [required()] }
                />
                <TextInput source="amountOff" validate={ [required()] } />
                <SelectInput
                    name="duration"
                    source="duration"
                    choices={ couponDuration }
                    validate={ [required()] }
                />
                <FormDataConsumer<{ duration: string }>>
                    {({
                          formData,
                          scopedFormData,
                          ...rest
                      }: FormDataConsumerRenderParams<{ duration: string }>): ReactElement|null => {
                        if (formData?.duration?.toLowerCase() === 'repeating') {
                            return (
                                <TextInput source="durationInMonths" validate={[required()]}  />
                            );
                        }
                        return null;
                    } }
                </FormDataConsumer>
                <DateInput source="redeemBy" />
                <ReferenceArrayInput source="appliesToProducts" reference="subscription_products"  />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
